import React from "react";
import { Field, ErrorMessage } from "formik";

const CustomField = ({
  name,
  type = "text",
  placeholder,
  className,
  as = "input", // Default element type is input, but can be overridden by 'textarea' or others
  touched = {},
  errors = {},
  isArabic = false,
  isReadOnly = false,
}) => {
  const fieldTouched = touched?.[name];
  const fieldError = errors?.[name];

  return (
    <div className="w-100">
      <Field
        name={name}
        type={type}
        id={name}
        as={as}
        readOnly={isReadOnly}
        placeholder={placeholder}
        title={placeholder}
        className={`form-control ${isArabic ? "rtl" : ""} ${
          fieldTouched && fieldError ? "is-invalid" : ""
        } ${className}`}
      />
      <ErrorMessage name={name} component="div" className="text-danger" />
    </div>
  );
};

export default CustomField;
